import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=4ae1ad00&scoped=true&"
import script from "./FileDetail.vue?vue&type=script&lang=js&"
export * from "./FileDetail.vue?vue&type=script&lang=js&"
import style0 from "./FileDetail.vue?vue&type=style&index=0&id=4ae1ad00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae1ad00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae1ad00')) {
      api.createRecord('4ae1ad00', component.options)
    } else {
      api.reload('4ae1ad00', component.options)
    }
    module.hot.accept("./FileDetail.vue?vue&type=template&id=4ae1ad00&scoped=true&", function () {
      api.rerender('4ae1ad00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/File/FileDetail.vue"
export default component.exports